<div class="margins" fxLayout="column">
  <div class="header">
    <div fxLayout="row">
      <div fxLayout="column" fxLayoutAlign="center left">
        <div class="title-text">{{ 'ORDERPRICELIST.TITLE' | translate }}</div>
        <div class="sub-text">{{ 'ORDERPRICELIST.DESCRIPTION' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="line"></div>
  <div *ngIf="!ready" class="content" fxFlex="100%">
    {{ 'LOADING' | translate }}
  </div>

  <div *ngIf="ready" class="content" fxFlex="100%">
    <div *ngIf="modularPrice" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img
          *ngIf="imageSrc"
          [src]="imageSrc"
          class="mini-screenshot blue-background image-rounded-corners"
          height="64"
          width="64" />
      </div>
      <div class="row-label">cold room</div>
      <div fxFlex></div>
      <div class="row-value">{{ modularPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
    <div *ngIf="floorPrice" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img *ngIf="floorImage" [src]="floorImage" class="mini-screenshot" width="48" />
      </div>
      <div class="row-label">{{ floorType | translate }}</div>
      <div fxFlex></div>
      <div class="row-value">{{ floorPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
    <div *ngFor="let wallFinishPrice of wallFinishPrices | keyvalue">
      <div *ngIf="wallFinishPrice.value" class="row" fxLayout="row" fxLayout>
        <div class="row-image">
          <img
            [src]="getImageForWallFinish(wallFinishPrice.key)"
            class="mini-screenshot image-rounded-corners"
            width="36" />
        </div>
        <div class="row-label">
          {{ 'FINISHTYPES1.' + wallFinishPrice.key | translate }}
          <br />
          {{ 'FINISHTYPES2.' + wallFinishPrice.key | translate }}
        </div>
        <div fxFlex></div>
        <div class="row-value">{{ wallFinishPrice.value | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
      </div>
    </div>
    <div *ngFor="let door of doors" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img [src]="getDoorImage(door)" class="mini-screenshot" height="48" />
      </div>
      <div class="row-label">
        {{ getDoorText(door) }}
      </div>
      <div fxFlex></div>
      <div class="row-value">{{ door.salesPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
    <div *ngIf="ventilationProfilesPrice" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img class="mini-screenshot" src="assets/images/roosteringsprofielen.png" width="48" />
      </div>
      <div class="row-label">
        {{ 'STEP4.PROFILES' | translate }}
      </div>
      <div fxFlex></div>
      <div class="row-value">{{ ventilationProfilesPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
    <div *ngIf="plinthsPrice" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img *ngIf="plinthsImage" [src]="plinthsImage" class="mini-screenshot" width="32" />
      </div>
      <div class="row-label">
        {{ 'STEP4.PLINTHS' | translate }}
      </div>
      <div fxFlex></div>
      <div class="row-value">{{ plinthsPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
    <div *ngIf="ceilingMoldingsPrice" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img class="mini-screenshot" src="assets/images/moldings.jpg" width="48" />
      </div>
      <div class="row-label">{{ 'STEP4.CEILINGMOLDINGS' | translate }}</div>
      <div fxFlex></div>
      <div class="row-value">{{ ceilingMoldingsPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
    <div *ngIf="airPressureEqualizerValvePrice" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img class="mini-screenshot" src="assets/svg/drukvereffingsventiel.svg" width="48" />
      </div>
      <div class="row-label">
        {{ 'SUMMARY.AIRPRESSUREEQUALIZERVALVE' | translate }}&nbsp;
        <span *ngIf="airPressureEqualizerValveCount > 1">(x{{ airPressureEqualizerValveCount }})</span>
      </div>
      <div fxFlex></div>
      <div class="row-value">
        {{ airPressureEqualizerValvePrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}
      </div>
    </div>
    <div *ngIf="uProfilesPrice" class="row" fxLayout fxLayout="row">
      <div class="row-image">
        <img class="mini-screenshot" src="assets/svg/u-profiel.svg" width="48" />
      </div>
      <div class="row-label">{{ 'SUMMARY.UPROFILES' | translate }}</div>
      <div fxFlex></div>
      <div class="row-value">{{ uProfilesPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
    <ng-container *ngFor="let innerWall of innerWalls">
      <div class="row" fxLayout="row" fxLayout>
        <div class="row-image">
          <img
            *ngIf="imageSrcInside"
            [src]="imageSrcInside"
            class="mini-screenshot blue-background image-rounded-corners"
            height="64"
            width="64" />
        </div>
        <div class="row-label">{{ 'WALL.4' | translate }} {{ getId(innerWall.id) }}</div>
        <div fxFlex></div>
        <div class="row-value">
          {{ innerWallPrice(innerWall) | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}
        </div>
      </div>
    </ng-container>
  </div>

  <div class="line"></div>
  <div class="price-information" fxLayout="column" fxLayoutAlign="center">
    <div fxLayout="row">
      <div class="price-information-label">{{ 'STEPCONTAINER.GROSSPRICE' | translate }}</div>
      <div fxFlex></div>
      <div class="price-information-value">{{ totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}</div>
    </div>
  </div>

  <div *ngIf="hasCollisions" class="sub-text error">{{ 'SUMMARY.NOORDERCONFLICTS' | translate }}</div>
  <app-isomasters-button
    (modularClick)="addToCart()"
    [disabled]="addedToCart || hasCollisions || loading"
    class="confirm-button">
    <div class="confirm-button-text" description fxLayout="row" fxLayoutAlign="center center">
      <span class="confirm-link">{{ 'ORDERPRICELIST.ADDTOCARD' | translate }}</span>
      <span
        [inlineSVG]="'assets/svg/shopping-cart.svg'"
        [setSVGAttributes]="{ width: '16px', height: '16px' }"
        class="icon"></span>
    </div>
  </app-isomasters-button>
</div>
